"use client";
import { useRouter } from "next/navigation";
import Image from "next/image";

export default function NotFound() {
  const router = useRouter();

  return (
    <section className="w-full min-h-screen bg-white flex items-center justify-center px-6 py-16 font-[BOOWIE]">

      <div className="max-w-5xl w-full flex flex-col items-center text-center">
        
        {/* <Image
          src="/Logo_NC.png"
          alt="Gitartha Logo"
          width={250}
          height={250}
          className="mb-6 opacity-80"
        /> */}

        <h1 className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold tracking-wide text-[#0E3147]">
          404
        </h1>

        <div className="w-24 h-[4px] mt-6 mb-8 bg-gradient-to-b from-[#CF973F] via-[#9D722C] to-[#FFD86D]" />

        <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium tracking-wider text-[#0E3147] mb-6">
          PAGE NOT FOUND
        </h2>

        <p className="text-[var(--secondary-text)] text-sm sm:text-base md:text-lg max-w-2xl leading-relaxed mb-10 text-justify sm:text-center">
          The page you are looking for does not exist or may have been moved.
          Let’s guide you back to the GITARTHA ecosystem.
        </p>

        <button
          onClick={() => router.push("/")}
          className="px-8 py-3 text-sm sm:text-base tracking-widest uppercase font-semibold 
                     bg-gradient-to-b from-[#CF973F] via-[#9D722C] to-[#FFD86D] 
                     text-black rounded-full shadow-md 
                     hover:scale-105 transition-transform duration-300"
        >
          Back to Home
        </button>

      </div>
    </section>
  );
}